import React, { useState } from "react";
import logo from "../../images/logo.png";
import "./header.css";

function Header() {
  const [isScroll, setScroll] = useState(false);
  const chaneScroll = () => {
    if (window.scrollY > 20) {
      setScroll(true);
    } else {
      setScroll(false);
    }
  };

  window.addEventListener("scroll", chaneScroll);
  return (
    <React.Fragment>
      <nav
        className={
          isScroll
            ? "navbar navbar-expand-lg fixed-top navbar-light border-bottom px-2 navbar-trans-active"
            : "navbar navbar-expand-lg fixed-top navbar-light border-bottom px-2 navbar-trans-active"
        }
        style={{ maxHeight: "none" }}
      >
        <div className="container-fluid">
          <a className="navbar-brand d-block " href="/">
            <img
              src={logo}
              alt="new logo"
              ezimgfmt="rs rscb1 src ng ngcb1"
              style={{ maxHeight: "80px" }}
              data-ezsrc={logo}
              ezoid="0.18851206252709396"
            />
          </a>

          {/* <h6 className="mb-0 d-lg-block d-none text-primary">
            Ganj Mesopotamia
          </h6>
          <h3 className="mb-0 d-lg-none d-block text-warning">
            Ganj Mesopotamia
          </h3> */}

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNavDropdown"
            aria-controls="navbarNavDropdown"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse mx-3" id="navbarNavDropdown">
            <ul className="navbar-nav ">
            <li className="nav-item">
                <a
                  className="nav-link mx-2 fw-bold text-uppercase"
                  aria-current="page"
                  href="/"
                >
                  Home
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link mx-2 fw-bold text-uppercase"
                  aria-current="page"
                  href="/"
                >
                  About US
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link mx-2 fw-bold text-uppercase"
                  href="/products"
                >
                  Products
                </a>
              </li>
              <li className="nav-item">
                <a
                  className="nav-link mx-2 fw-bold text-uppercase"
                  href="/contactus"
                >
                  Contact Us
                </a>
              </li>
              {/* <li className="nav-item">
                <a
                  className="nav-link mx-2 fw-bold text-uppercase"
                  href="aboutus"
                >
                  About Us
                </a>
              </li> */}
            </ul>
            {/* <ul className="navbar-nav ms-auto d-none d-lg-inline-flex">
              <li className="nav-item">
                <a
                  href="tel:+964 750 457 6730"
                  className="btn btn-outline-warning my-2 my-sm-0 bg-primary px-3 text-white"
                  type="submit"
                >
                  Call Phone
                </a>
              </li>
            </ul> */}
            <ul className="navbar-nav ms-auto d-none d-lg-inline-flex">
  {/* <li className="nav-item d-flex align-items-center me-3">
    <i className="fas fa-phone-alt me-2"></i>
    <a href="tel:+9647504576730" className="text-decoration-none text-dark">
    +964-750-472-2395
    </a>
  </li> */}
  <li className="nav-item d-flex align-items-center">
    <i className="fas fa-envelope me-2"></i>
    <a href="mailto:example@email.com" className="text-decoration-none text-dark">
    info@ganjtrading.com
    </a>
  </li>
</ul>

          </div>
        </div>
      </nav>
    </React.Fragment>
  );
}

export default Header;
